import {
  EDITOR_CREATE_SNIPPET_TEMPLATE_BEGIN,
  EDITOR_CREATE_SNIPPET_TEMPLATE_SUCCESS,
  EDITOR_CREATE_SNIPPET_TEMPLATE_FAILURE,
  EDITOR_CREATE_SNIPPET_TEMPLATE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../home/app_util';

export function createSnippetTemplate(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EDITOR_CREATE_SNIPPET_TEMPLATE_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/snippet-templates`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EDITOR_CREATE_SNIPPET_TEMPLATE_SUCCESS,
              data: res.data,
            });
            Mixpanel.track('Created Snippet on builder', { uuid: res.data.uuid });
            toast.success('Snippet Created Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EDITOR_CREATE_SNIPPET_TEMPLATE_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create Snippet  on builder');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EDITOR_CREATE_SNIPPET_TEMPLATE_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create Snippet on builder');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateSnippetTemplateError() {
  return {
    type: EDITOR_CREATE_SNIPPET_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_CREATE_SNIPPET_TEMPLATE_BEGIN:
      return {
        ...state,
        createSnippetTemplatePending: true,
        createSnippetTemplateError: null,
      };

    case EDITOR_CREATE_SNIPPET_TEMPLATE_SUCCESS:
      return {
        ...state,
        createSnippetTemplatePending: false,
        createSnippetTemplateError: null,
        snippets: action.data,
        showEmailSetting: false,
      };

    case EDITOR_CREATE_SNIPPET_TEMPLATE_FAILURE:
      return {
        ...state,
        createSnippetTemplatePending: false,
        createSnippetTemplateError: action.data.error,
      };

    case EDITOR_CREATE_SNIPPET_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        createSnippetTemplateError: null,
      };

    default:
      return state;
  }
}
